import { PropsWithChildren } from 'react'
import { useCustomDomain } from '../hooks/useCustomDomain'
import SeoHead from './SeoHead'
import { siteTitle } from '../helpers/seo'

type SectionProps = PropsWithChildren<{
  className?: string
  title: string
}>

const Section = ({ title, children, className }: SectionProps) => {
  const { customDomain } = useCustomDomain()

  return (
    <section className={className}>
      <SeoHead title={siteTitle([title], customDomain)} />
      <div>{children}</div>
    </section>
  )
}

export default Section
